import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterService } from '../../account/register/register.service';
import { LoginService } from '../../core/login/login.service';
import { AccountService } from '../../core/auth/account.service';
import { COUNTRIES } from '../../app.constants';
import { UserService } from '../../core/user/user.service';
import { LeaveNumberModalComponent } from '../login/leave-number-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../account/register/register.service";
import * as i4 from "../../core/login/login.service";
import * as i5 from "../../core/auth/account.service";
import * as i6 from "../../core/user/user.service";
import * as i7 from "../../shared/language/language-selector/language-selector.component";
import * as i8 from "../../shared/support/support-dropdown.component";
import * as i9 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/forms";
import * as i11 from "@fortawesome/angular-fontawesome";
import * as i12 from "@angular/common";
import * as i13 from "../../shared/password-strength-meter/password-strength-meter.component";
import * as i14 from "../../shared/consent-text/consent-text.component";
import * as i15 from "@ngx-translate/core";
function RegisterCoronaComponent_div_25_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 22);
} }
function RegisterCoronaComponent_div_25_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterCoronaComponent_div_25_fa_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 22);
} }
function RegisterCoronaComponent_div_25_fa_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterCoronaComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵelementStart(2, "p", 21);
    i0.ɵɵtemplate(3, RegisterCoronaComponent_div_25_fa_icon_3_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(4, RegisterCoronaComponent_div_25_fa_icon_4_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(5, "span", 52);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 53);
    i0.ɵɵelementStart(8, "p", 54);
    i0.ɵɵtemplate(9, RegisterCoronaComponent_div_25_fa_icon_9_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(10, RegisterCoronaComponent_div_25_fa_icon_10_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(11, "span", 55);
    i0.ɵɵelement(12, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.isLetterNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isLetterNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.isMax20);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMax20);
} }
function RegisterCoronaComponent_fa_icon_41_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 57);
    i0.ɵɵlistener("click", function RegisterCoronaComponent_fa_icon_41_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.onTogglePassword(ctx_r12.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterCoronaComponent_fa_icon_42_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 58);
    i0.ɵɵlistener("click", function RegisterCoronaComponent_fa_icon_42_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onTogglePassword(ctx_r14.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterCoronaComponent_fa_icon_48_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 57);
    i0.ɵɵlistener("click", function RegisterCoronaComponent_fa_icon_48_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.onTogglePassword(ctx_r16.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterCoronaComponent_fa_icon_49_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 58);
    i0.ɵɵlistener("click", function RegisterCoronaComponent_fa_icon_49_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onTogglePassword(ctx_r18.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterCoronaComponent_div_50_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 22);
} }
function RegisterCoronaComponent_div_50_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 56);
} }
function RegisterCoronaComponent_div_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "div", 49);
    i0.ɵɵelementStart(2, "p", 21);
    i0.ɵɵtemplate(3, RegisterCoronaComponent_div_50_fa_icon_3_Template, 1, 0, "fa-icon", 50);
    i0.ɵɵtemplate(4, RegisterCoronaComponent_div_50_fa_icon_4_Template, 1, 0, "fa-icon", 51);
    i0.ɵɵelement(5, "span", 59);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.passwordsMatch);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.passwordsMatch);
} }
function RegisterCoronaComponent_option_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 60);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r22 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", country_r22);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(country_r22);
} }
export class RegisterCoronaComponent {
    constructor(activatedRoute, ngbModal, registerService, loginService, accountService, elementRef, router, userService) {
        this.activatedRoute = activatedRoute;
        this.ngbModal = ngbModal;
        this.registerService = registerService;
        this.loginService = loginService;
        this.accountService = accountService;
        this.elementRef = elementRef;
        this.router = router;
        this.userService = userService;
        this.generatedUsername = '';
        this.isLetterNumber = true;
        this.isMax20 = true;
        this.isMin8 = false;
        this.passwordsMatch = true;
        this.toggle = '';
        this.focusClass = 'mb-2';
        this.TOGGLE_USERNAME = 'TOGGLE_USERNAME';
        this.TOGGLE_PASSWORD = 'TOGGLE_PASSWORD';
        this.TOGGLE_CONFIRM = 'TOGGLE_CONFIRM';
        this.passwordTypeInput = 'password';
        this.confirmTypeInput = 'password';
        this.passwordEyeSlashed = false;
        this.confirmEyeSlashed = false;
        this.TYPE_PASSWORD = 'TYPE_PASSWORD';
        this.TYPE_CONFIRM = 'TYPE_CONFIRM';
        this.specialCharacters = new RegExp('^[a-zA-Z0-9]+$');
        this.pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        this.modalOptions = { windowClass: 'modal-window', size: 'md' };
        this.countries = COUNTRIES;
        this.isUsed = false;
        this.displayNLHelpHeader = false;
        this.consents = [];
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        if (this.accountService.isAuthenticated()) {
            this.loginService.redirectToHomepage();
        }
        this.generateUsername();
    }
    generateUsername() {
        this.generateUsernameSubscription = this.registerService.generateUsername().subscribe(response => (this.generatedUsername = response));
    }
    getLoginRegion() {
        this.userService.getLoginCountry().subscribe(regionResponse => {
            console.log(regionResponse);
            if (regionResponse === 'Netherlands')
                this.displayNLHelpHeader = true;
            this.displayNLHelpModal();
        }, regionError => {
            console.log(regionError);
        });
    }
    displayNLHelpModal() {
        const modalRef = this.ngbModal.open(LeaveNumberModalComponent, this.modalOptions);
        modalRef.componentInstance.leaveNumberModalRef = modalRef;
        modalRef.componentInstance.displayNLHelpHeader = this.displayNLHelpHeader;
        modalRef.componentInstance.errorMessage = this.errorMessage;
    }
    onRegister(form) {
        console.log(form.value);
        let login = form.value.login;
        let email = form.value.email.trim();
        let password = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        let voucherCode = this.activatedRoute.snapshot.queryParamMap.get('voucherCode');
        let country = form.value.country;
        let checkbox = form.value.checkbox;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (login.length === 0) {
            this.errorMessage = 'register.messages.error.usernameRequired';
            this.getLoginRegion();
            return;
        }
        if (login.length > 20) {
            this.errorMessage = 'register.messages.error.usernameMaxTwenty';
            this.getLoginRegion();
            return;
        }
        if (!this.specialCharacters.test(login)) {
            this.errorMessage = 'register.messages.error.numberLetterOnly';
            this.getLoginRegion();
            return;
        }
        if (email.length === 0) {
            this.errorMessage = 'register.messages.error.emailRequired';
            this.getLoginRegion();
            return;
        }
        if (!this.pattern.test(email)) {
            this.errorMessage = 'register.messages.error.invalidEmail';
            this.getLoginRegion();
            return;
        }
        if (password.length < 8) {
            this.errorMessage = 'register.messages.error.atLeast8';
            this.getLoginRegion();
            return;
        }
        if (confirmPassword !== password) {
            this.errorMessage = 'register.messages.error.doNotMatch';
            this.getLoginRegion();
            return;
        }
        // if (!this.specialCharacters.test(password)) {
        //   this.errorMessage = 'register.messages.error.numberLetterOnlyPassword';
        //   this.getLoginRegion();
        //   return;
        // }
        if (!country) {
            this.errorMessage = 'register.messages.error.countryRequired';
            this.getLoginRegion();
            return;
        }
        if (!checkbox) {
            this.errorMessage = 'register.messages.error.agreeTerms';
            this.getLoginRegion();
            return;
        }
        let registrationData = { login, email, password, voucherCode, country, timezone, consents: this.consents };
        console.log(registrationData);
        this.registrationSubscription = this.registerService.save(registrationData).subscribe(response => {
            if (response === "Voucher code doesn't exist!") {
                this.errorMessage = 'register.messages.error.noVoucherCode';
                this.getLoginRegion();
                return;
            }
            if (response === 'There are no more usages left for the voucher code!') {
                this.errorMessage = 'register.messages.error.noUsageVoucherCode';
                this.getLoginRegion();
                return;
            }
            if (response === 'Voucher code expired!') {
                this.errorMessage = 'register.messages.error.voucherCodeExpired';
                this.getLoginRegion();
                return;
            }
            if (response === "Voucher code doesn't run!") {
                this.errorMessage = 'register.messages.error.noRunVoucherCode';
                this.getLoginRegion();
                return;
            }
            if (response === 'OK') {
                let request = { email, password, rememberMe: true };
                this.loginSubscription = this.loginService.login(request).subscribe(() => {
                    this.router.navigate(['/onboarding']).then();
                }, error => {
                    console.log(error);
                    this.getLoginRegion();
                });
            }
        }, response => {
            let errorKey = JSON.parse(response.error).errorKey;
            if (errorKey === 'userexists' || errorKey === 'emailexists') {
                this.isUsed = true;
                this.errorMessage = 'register.messages.error.' + errorKey;
                this.getLoginRegion();
                return;
            }
        });
    }
    modalNavigate(url) {
        this.router.navigate([url]).then(response => console.log(response));
    }
    focusInOut(toggleField, focusIn) {
        this.toggle = focusIn ? toggleField : '';
        console.log(this.toggle);
        this.focusClass = focusIn ? 'mb-2' : '';
        console.log(this.focusClass);
    }
    passwordCheck(form) {
        let firstPassword = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        this.isMin8 = firstPassword.length >= 8;
        this.passwordsMatch = firstPassword === confirmPassword;
    }
    onTogglePassword(type) {
        if (type === this.TYPE_PASSWORD) {
            this.passwordEyeSlashed = !this.passwordEyeSlashed;
            this.passwordTypeInput === 'text' ? (this.passwordTypeInput = 'password') : (this.passwordTypeInput = 'text');
        }
        else if (type === this.TYPE_CONFIRM) {
            this.confirmEyeSlashed = !this.confirmEyeSlashed;
            this.confirmTypeInput === 'text' ? (this.confirmTypeInput = 'password') : (this.confirmTypeInput = 'text');
        }
    }
    updateConsents(consent) {
        this.consents = this.consents.filter(c => c.name !== consent.name);
        this.consents.push(consent);
    }
    setPasswordText(form) {
        this.passwordText = form.value.password.trim();
    }
    ngOnDestroy() {
        if (this.registrationSubscription) {
            this.registrationSubscription.unsubscribe();
        }
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.generateUsernameSubscription) {
            this.generateUsernameSubscription.unsubscribe();
        }
    }
}
RegisterCoronaComponent.ɵfac = function RegisterCoronaComponent_Factory(t) { return new (t || RegisterCoronaComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.RegisterService), i0.ɵɵdirectiveInject(i4.LoginService), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i6.UserService)); };
RegisterCoronaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegisterCoronaComponent, selectors: [["register-corona"]], decls: 66, vars: 37, consts: [[1, "navbar", "navbar-dark", "d-flex", "justify-content-end"], [1, "row"], [1, "float-right", "pl-2", "pr-2"], [1, "page", 2, "background-color", "white"], [1, "page-single", 2, "background-color", "white", "border-radius", "20px"], [1, "container-fluid"], [1, "row", "fadeIn", "animated"], [1, "offset-sm-2", "col-sm-8", "offset-md-3", "col-md-6", "offset-lg-3", "col-lg-6", "offset-xl-4", "col-xl-4"], ["id", "inuka-header-default", 2, "background-color", "#eef6f4", "text-align", "center", "margin-top", "10px", "border-radius", "6px"], ["src", "../../../../content/images/inuka/logo-circle-black-2x.png", "alt", "logo-circle-black-2x"], [2, "padding-left", "5px", "letter-spacing", "0.1em", "font-weight", "bold"], ["jhiTranslate", "register.header.coachSupport", 1, "m-2", 2, "font-weight", "bold", "color", "black", "text-transform", "uppercase"], ["jhiTranslate", "register.paragraph.payWhatYouCan", 2, "color", "black", "font-weight", "bold", "font-size", "medium"], [3, "ngSubmit"], ["registrationForm", "ngForm"], ["id", "username-div", 2, "position", "relative"], ["type", "text", "id", "username", "name", "login", "required", "", 1, "form-control", 2, "border-radius", "6px", 3, "ngModel", "placeholder", "ngModelChange", "focusin", "focusout"], ["icon", "undo", 1, "undo", 3, "click"], ["class", "row mt-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "col-12", 2, "float", "left", "padding", "0 10px 0 20px"], [2, "float", "left", "margin-bottom", "0!important"], ["icon", "check", 1, "check"], ["jhiTranslate", "register.paragraph.confidentialIdentity", 1, "indicator-text"], [1, "form-group", "mb-2"], ["type", "text", "id", "email", "name", "email", "ngModel", "", "required", "", 1, "form-control", 3, "placeholder"], ["hidden", "", 1, "input", "group", "mb-2"], ["type", "text", "id", "voucher-code", 1, "form-control", 3, "placeholder"], ["id", "new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "new-password", "name", "password", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "ngModelChange"], ["class", "eye", "icon", "eye", 3, "click", 4, "ngIf"], ["class", "eye", "icon", "eye-slash", 3, "click", 4, "ngIf"], [3, "password"], ["id", "confirmed-new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "confirmed-new-password", "name", "confirmPassword", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "keyup"], ["id", "country", "ngModel", "", "name", "country", "required", "", 1, "form-control", 2, "position", "relative", "z-index", "10"], ["value", "", "jhiTranslate", "register.paragraph.selectCountry", "disabled", "", "selected", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "row", "mt-2", "mb-3", 2, "padding-left", "18px"], [1, "form-group", "col-1", 2, "padding-right", "0!important"], ["id", "confirm-checkbox", "type", "checkbox", "ngModel", "", "name", "checkbox", "required", "", 1, "form-control", "customcheck", "checkmark", "mb-2", 2, "color", "#44A38D"], [1, "col-11", 2, "font-size", "12px", "padding", "0!important"], ["name", "inuka-terms", 3, "onChange"], ["id", "registrationError", 1, "col-12"], [1, "col-12"], ["id", "sign-me-up-button", "type", "submit", "jhiTranslate", "register.button.signMeUp", 1, "btn", "btn-gradient-primary", "btn-block", "font-weight-bold"], [2, "margin", "10px"], ["jhiTranslate", "register.paragraph.haveAccount", 2, "text-align", "center", "margin-bottom", "0"], [1, "row", "mt-2"], [1, "col-6", 2, "float", "left", "padding", "0 10px 0 20px"], ["class", "check", "icon", "check", 4, "ngIf"], ["class", "times", "icon", "times", 4, "ngIf"], ["jhiTranslate", "register.paragraph.lettersNumbers", 1, "indicator-text"], [1, "col-6", 2, "padding", "0 10px 0 10px"], [2, "text-align", "center", "margin-bottom", "0!important"], ["jhiTranslate", "register.paragraph.maxChar", 1, "indicator-text"], ["icon", "times", 1, "times"], ["icon", "eye", 1, "eye", 3, "click"], ["icon", "eye-slash", 1, "eye", 3, "click"], ["jhiTranslate", "register.paragraph.passwordsMatch", 1, "indicator-text", 2, "padding-left", "3px"], [3, "ngValue"]], template: function RegisterCoronaComponent_Template(rf, ctx) { if (rf & 1) {
        const _r23 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "nav", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "language-selector");
        i0.ɵɵelement(3, "support-dropdown", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelement(10, "br");
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelement(12, "img", 9);
        i0.ɵɵelementStart(13, "span", 10);
        i0.ɵɵtext(14, "inuka");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "h3", 11);
        i0.ɵɵelement(16, "p", 12);
        i0.ɵɵelement(17, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "br");
        i0.ɵɵelementStart(19, "form", 13, 14);
        i0.ɵɵlistener("ngSubmit", function RegisterCoronaComponent_Template_form_ngSubmit_19_listener() { i0.ɵɵrestoreView(_r23); const _r0 = i0.ɵɵreference(20); return ctx.onRegister(_r0); });
        i0.ɵɵelementStart(21, "div", 15);
        i0.ɵɵelementStart(22, "input", 16);
        i0.ɵɵlistener("ngModelChange", function RegisterCoronaComponent_Template_input_ngModelChange_22_listener($event) { return ctx.generatedUsername = $event; })("focusin", function RegisterCoronaComponent_Template_input_focusin_22_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, true); })("focusout", function RegisterCoronaComponent_Template_input_focusout_22_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, false); });
        i0.ɵɵpipe(23, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "fa-icon", 17);
        i0.ɵɵlistener("click", function RegisterCoronaComponent_Template_fa_icon_click_24_listener() { return ctx.generateUsername(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(25, RegisterCoronaComponent_div_25_Template, 13, 4, "div", 18);
        i0.ɵɵelementStart(26, "div", 19);
        i0.ɵɵelementStart(27, "div", 20);
        i0.ɵɵelementStart(28, "p", 21);
        i0.ɵɵelement(29, "fa-icon", 22);
        i0.ɵɵelement(30, "span", 23);
        i0.ɵɵelement(31, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 24);
        i0.ɵɵelement(33, "input", 25);
        i0.ɵɵpipe(34, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 26);
        i0.ɵɵelement(36, "input", 27);
        i0.ɵɵpipe(37, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 28);
        i0.ɵɵelementStart(39, "input", 29);
        i0.ɵɵlistener("focusin", function RegisterCoronaComponent_Template_input_focusin_39_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, true); return ctx.showPasswordMeter = true; })("focusout", function RegisterCoronaComponent_Template_input_focusout_39_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, false); return ctx.showPasswordMeter = false; })("ngModelChange", function RegisterCoronaComponent_Template_input_ngModelChange_39_listener() { i0.ɵɵrestoreView(_r23); const _r0 = i0.ɵɵreference(20); ctx.passwordCheck(_r0); return ctx.setPasswordText(_r0); });
        i0.ɵɵpipe(40, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(41, RegisterCoronaComponent_fa_icon_41_Template, 1, 0, "fa-icon", 30);
        i0.ɵɵtemplate(42, RegisterCoronaComponent_fa_icon_42_Template, 1, 0, "fa-icon", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div");
        i0.ɵɵelement(44, "password-strength-meter-component", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 33);
        i0.ɵɵelementStart(46, "input", 34);
        i0.ɵɵlistener("focusin", function RegisterCoronaComponent_Template_input_focusin_46_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, true); })("focusout", function RegisterCoronaComponent_Template_input_focusout_46_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, false); })("keyup", function RegisterCoronaComponent_Template_input_keyup_46_listener() { i0.ɵɵrestoreView(_r23); const _r0 = i0.ɵɵreference(20); return ctx.passwordCheck(_r0); });
        i0.ɵɵpipe(47, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(48, RegisterCoronaComponent_fa_icon_48_Template, 1, 0, "fa-icon", 30);
        i0.ɵɵtemplate(49, RegisterCoronaComponent_fa_icon_49_Template, 1, 0, "fa-icon", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(50, RegisterCoronaComponent_div_50_Template, 7, 2, "div", 18);
        i0.ɵɵelementStart(51, "div", 24);
        i0.ɵɵelementStart(52, "select", 35);
        i0.ɵɵelement(53, "option", 36);
        i0.ɵɵtemplate(54, RegisterCoronaComponent_option_54_Template, 2, 2, "option", 37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div", 38);
        i0.ɵɵelementStart(56, "div", 39);
        i0.ɵɵelement(57, "input", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "div", 41);
        i0.ɵɵelementStart(59, "consent-text", 42);
        i0.ɵɵlistener("onChange", function RegisterCoronaComponent_Template_consent_text_onChange_59_listener($event) { return ctx.updateConsents($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 1);
        i0.ɵɵelement(61, "div", 43);
        i0.ɵɵelementStart(62, "div", 44);
        i0.ɵɵelement(63, "button", 45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(64, "hr", 46);
        i0.ɵɵelement(65, "p", 47);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(21);
        i0.ɵɵclassMapInterpolate1("form-group ", ctx.focusClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(23, 27, "register.placeholder.username"));
        i0.ɵɵproperty("ngModel", ctx.generatedUsername);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_USERNAME);
        i0.ɵɵadvance(8);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(34, 29, "register.placeholder.email"));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(37, 31, "register.placeholder.voucherCode"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.passwordTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 33, "register.placeholder.password"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.showPasswordMeter ? "" : "d-none");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("password", ctx.passwordText);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.confirmTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(47, 35, "register.placeholder.repeatPassword"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_CONFIRM);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.countries);
    } }, directives: [i2.NgbNavbar, i7.LanguageSelectorComponent, i8.SupportDropdownComponent, i9.JhiTranslateDirective, i10.ɵNgNoValidate, i10.NgControlStatusGroup, i10.NgForm, i10.DefaultValueAccessor, i10.RequiredValidator, i10.NgControlStatus, i10.NgModel, i11.FaIconComponent, i12.NgIf, i13.PasswordStrengthMeterComponent, i10.SelectControlValueAccessor, i10.NgSelectOption, i10.ɵNgSelectMultipleOption, i12.NgForOf, i10.CheckboxControlValueAccessor, i10.CheckboxRequiredValidator, i14.ConsentTextComponent], pipes: [i15.TranslatePipe], styles: [".consent-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif;font-style:normal;font-size:11px;line-height:140% !important;color:#0a4a3a}"] });
